module.exports = __webpack_public_path__ + "static/media/placed-order.0ec55c4a.svg";